
export const fetchRadixFaqs=async()=>{
    try {
        const response=await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/radix-faqs`);
        const data=await response.json();
        return data.data;
    } catch (error) {
        console.error('Error while fetching the Radix Faqs: ',error);
    }
}
export const fetchRadixStrengths=async()=>{
    try {
        const response=await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/radix-strengths?populate[0]=Img`);
        const data=await response.json();
        return data.data;
    } catch (error) {
        console.error('Error while fetching the Radix Strength: ',error);
    }
}

export const fetchTestimonials=async()=>{
    try {
        const response=await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/radix-testimonials`);
        const data=await response.json();
        return data.data;
    } catch (error) {
        console.error("Error while fetching the Radix Testimonial: ",error);
    }
}
export const fetchMenus=async()=>{
    try {
        const response=await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/radix-menus?populate[0]=radix_submenus&sort=menu:asc`);
        const data=await response.json();
        return data.data;
    } catch (error) {
        console.error("Error while fetching Radix Menus: ",error);
    }
}
export const fetchSubMenus=async()=>{
    try {
        const response=await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/radix-submenus`);
        const data=await response.json();
        return data.data;
    } catch (error) {
        console.error("Error while fetching Radix Submenus: ",error);
    }
}